<template>
    <div class="image-processing-modal">
        <a-modal
            title="Resim İşleme Ayarları"
            :visible="true"
            @cancel="$emit('close')"
            :footer="null"
            width="1050px"
            :maskClosable="false"
        >
            <ImageProcessingSettings :storyId="storyId" @close="$emit('close')" />
        </a-modal>
    </div>
</template>

<script>
import ImageProcessingSettings from "../../../../ai/files/ImageProcessingSettings.vue";

export default {
    name: "ImageProcessingModal",
    components: {
        ImageProcessingSettings,
    },
    props: {
        storyId: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.image-processing-modal {
    :deep(.ant-modal-body) {
        padding: 0;
    }
}
</style>
